export default function() {
  return {
    isOpen: false,

    init() {1
      for (const option of this.$el.querySelectorAll('.dropdown li')) {
        option.addEventListener('click', () => {
          if (this.isOpen) this.isOpen = false;

          this.$el.querySelector('.app-select-input').value = option.dataset.value;
          this.$el.querySelector('.app-select-input').dispatchEvent(new Event('input'));
        });
      }
    },

    toggleOpen() {
      this.isOpen = ! this.isOpen;
    }
  };
}